import React, { useRef } from 'react';
import { testimonials } from '../data/siteData';

import {
  FaQuoteLeft,
  FaArrowLeft,
  FaArrowRight
} from 'react-icons/fa';

function Testimonials() {

  const sliderRef = useRef();

  const scrollLeft = () => {
    sliderRef.current.scrollBy({
      left: -380,
      behavior: 'smooth'
    });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({
      left: 380,
      behavior: 'smooth'
    });
  };

  return (
    <section
      className="section bg-light"
      id="testimonials"
    >
      <div className="container">

        <div className="section-header">
          <p className="section-subtitle">
            Testimonials
          </p>

          <h2 className="section-title">
            What Our Clients Say
          </h2>
        </div>

        <div className="testimonials-wrapper">

          {/* LEFT BUTTON */}
          <button
            className="slider-btn left"
            onClick={scrollLeft}
          >
            <FaArrowLeft />
          </button>

          {/* SLIDER */}
          <div
            className="testimonials-grid"
            ref={sliderRef}
          >
            {testimonials.map((item, index) => (
              <div
                className="testimonial-card"
                key={index}
              >
                <FaQuoteLeft className="quote-icon" />

                <p>{item.message}</p>

                <div>
                  <h4>{item.name}</h4>
                  <span>{item.company}</span>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT BUTTON */}
          <button
            className="slider-btn right"
            onClick={scrollRight}
          >
            <FaArrowRight />
          </button>

        </div>

      </div>
    </section>
  );
}

export default Testimonials;